import React from 'react';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {ParallaxBanner} from 'react-scroll-parallax';
import './Banner.less';

const Banner = ({isMobile, image, children, ...rest}) => {
    return (
        <ParallaxBanner
            className="Banner"
            disabled={isMobile}
            style={{height: 'auto'}}
            layers={[
                {
                    image,
                    amount: 0.4,
                },
            ]}
            {...rest}
        >
            <div className="Banner__content text-center">{children}</div>
        </ParallaxBanner>
    );
};

export default determineIfMobile(Banner);
